var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-listing" },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "el-button",
              {
                staticClass: "import-btn-header",
                attrs: { type: "success", icon: "el-icon-upload2" },
                on: { click: _vm.handleOpenGroupShelfImportDialog },
              },
              [_vm._v("批量导入")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "add-btn",
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.handleOpenAddGroupDialog },
              },
              [_vm._v("添加分组")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "content-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("分组列表"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _vm.selectedTableProducts.length > 0
                          ? _c(
                              "el-button",
                              {
                                staticClass: "batch-delete-btn",
                                attrs: { type: "text" },
                                on: { click: _vm.handleBatchRemove },
                              },
                              [
                                _c("i", { staticClass: "el-icon-delete" }),
                                _vm._v(
                                  "\n                批量删除(" +
                                    _vm._s(_vm.selectedTableProducts.length) +
                                    ")\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "card-count" }, [
                          _vm._v(
                            "共 " + _vm._s(_vm.tableData.length) + " 个分组"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "groupListTableRef",
                          staticClass: "apple-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.tableData,
                            "header-cell-style": _vm.headerCellStyle,
                            "max-height": "550px",
                          },
                          on: {
                            "selection-change": _vm.handleTableSelectionChange,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "id",
                              label: "分组ID",
                              width: "90",
                              center: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "id-tag" }, [
                                      _vm._v("#" + _vm._s(scope.row.id)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "分组名称",
                              "min-width": "130",
                              center: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", { staticClass: "product-info" }, [
                                      _c(
                                        "div",
                                        { staticClass: "product-name" },
                                        [_vm._v(_vm._s(scope.row.name))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-category" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.regionCategory || "-"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "80",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "remove-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "content-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("批量操作"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "formRef",
                          staticClass: "apple-form",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.rules,
                            "label-position": "top",
                            "label-width": "auto",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "选择操作类型",
                                prop: "operation",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "operation-radio",
                                  model: {
                                    value: _vm.form.operation,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "operation", $$v)
                                    },
                                    expression: "form.operation",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "1" } },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-upload2",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("上架")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "0" } },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-download",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("下架")]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "选择场景",
                                prop: "menuTypeList",
                              },
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  staticClass: "scene-checkbox-group",
                                  model: {
                                    value: _vm.form.scene,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "scene", $$v)
                                    },
                                    expression: "form.scene",
                                  },
                                },
                                _vm._l(_vm.menuTypeList, function (value) {
                                  return _c(
                                    "el-checkbox-button",
                                    {
                                      key: value.code,
                                      attrs: { label: value.code },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(value.desc) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "选择门店", prop: "stores" } },
                            [
                              _c(
                                "div",
                                { staticClass: "store-section-header" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: { click: _vm.handleCheckAll },
                                    },
                                    [_vm._v("全选")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: { click: _vm.handleUncheckAll },
                                    },
                                    [_vm._v("取消全选")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: _vm.handleOpenStoreImportDialog,
                                      },
                                    },
                                    [_vm._v("导入门店")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "store-section" }, [
                                _c(
                                  "div",
                                  { staticClass: "store-header" },
                                  [
                                    _c("el-input", {
                                      staticClass: "store-search",
                                      attrs: {
                                        placeholder: "搜索门店或区域",
                                        "prefix-icon": "el-icon-search",
                                        clearable: "",
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.storeSearch,
                                        callback: function ($$v) {
                                          _vm.storeSearch = $$v
                                        },
                                        expression: "storeSearch",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "store-tree-container" },
                                  [
                                    _c("el-tree", {
                                      ref: "treeRef",
                                      staticClass: "apple-tree",
                                      attrs: {
                                        data: _vm.treeData,
                                        "show-checkbox": "",
                                        "default-expand-all": false,
                                        "node-key": "id",
                                        props: {
                                          label: "label",
                                          children: "children",
                                        },
                                        "filter-node-method":
                                          _vm.filterStoreNode,
                                        "empty-text": "未找到匹配的门店",
                                      },
                                      on: { check: _vm.handleCheck },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var node = ref.node
                                            var data = ref.data
                                            return _c(
                                              "span",
                                              {
                                                staticClass: "custom-tree-node",
                                              },
                                              [
                                                _c("i", {
                                                  class: data.isRegion
                                                    ? "el-icon-office-building"
                                                    : "el-icon-s-shop",
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(data.label)),
                                                ]),
                                                _vm._v(" "),
                                                data.storeCount
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "store-count",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              data.storeCount
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "store-footer" }, [
                                  _c(
                                    "span",
                                    { staticClass: "selected-count" },
                                    [
                                      _vm._v(
                                        "已选择 " +
                                          _vm._s(_vm.selectedStoreCount) +
                                          " 家门店"
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-footer" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        on: { click: _vm.handleCancel },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "schedule-btn",
                        attrs: {
                          type: "warning",
                          loading: _vm.scheduleSubmitting,
                        },
                        on: { click: _vm.handleOpenScheduleDialog },
                      },
                      [
                        _c("i", { staticClass: "el-icon-time" }),
                        _vm._v("\n            定时操作\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "task-manage-btn",
                        attrs: { type: "info" },
                        on: { click: _vm.handleOpenTaskManage },
                      },
                      [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v("\n            任务管理\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "submit-btn",
                        attrs: { type: "primary", loading: _vm.submitting },
                        on: { click: _vm.handleSubmit },
                      },
                      [
                        _vm._v(
                          "\n            确认" +
                            _vm._s(
                              _vm.form.operation === "1" ? "上架" : "下架"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "add-product-dialog",
          attrs: {
            title: "添加分组",
            visible: _vm.addDialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              { staticClass: "search-section" },
              [
                _c("el-input", {
                  staticClass: "product-search",
                  attrs: {
                    placeholder: "搜索分组名称、副标题、适用区域...",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                    loading: _vm.groupSearchLoading,
                  },
                  on: { input: _vm.handleGroupSearch },
                  model: {
                    value: _vm.groupSearch,
                    callback: function ($$v) {
                      _vm.groupSearch = $$v
                    },
                    expression: "groupSearch",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "product-list-container" },
              [
                _c(
                  "el-table",
                  {
                    ref: "groupTableRef",
                    staticClass: "product-select-table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.filteredGroupList,
                      "header-cell-style": _vm.headerCellStyle,
                      "max-height": "350px",
                    },
                    on: { "selection-change": _vm.handleGroupSelection },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "55",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "id", label: "分组ID", width: "90" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "id-tag" }, [
                                _vm._v("#" + _vm._s(scope.row.id)),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "分组名称",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "product-info" }, [
                                _c("div", { staticClass: "product-name" }, [
                                  _vm._v(_vm._s(scope.row.name)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "product-category" }, [
                                  _vm._v(
                                    _vm._s(scope.row.regionCategory || "-")
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseAddDialog } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.selectedGroups.length === 0,
                  },
                  on: { click: _vm.handleConfirmAdd },
                },
                [_vm._v("\n        确认添加\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "import-dialog goods-shelf-import-dialog",
          attrs: {
            title: "批量导入分组上下架",
            visible: _vm.importDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
            close: _vm.handleImportDialogClose,
          },
        },
        [
          _c(
            "el-alert",
            {
              staticClass: "import-alert",
              attrs: {
                title: "导入说明",
                type: "info",
                closable: false,
                "show-icon": "",
              },
            },
            [
              _c("div", { attrs: { slot: "default" }, slot: "default" }, [
                _c("p", [
                  _vm._v(
                    "导入字段：分组名称，场景，上架/下架，门店ID，门店名称"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("• 分组名称：必填，要操作的分组名称")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    '• 场景：必填，可填写"堂食"、"自提"、"外卖"，支持多个场景用逗号分隔，如：堂食,外卖'
                  ),
                ]),
                _vm._v(" "),
                _c("p", [_vm._v('• 上架/下架：必填，填写"上架"或"下架"')]),
                _vm._v(" "),
                _c("p", [_vm._v("• 门店ID：必填，指定门店ID（第三方门店ID）")]),
                _vm._v(" "),
                _c("p", [_vm._v("• 门店名称：选填，门店名称备注信息")]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "importFormRef",
              staticClass: "import-form",
              attrs: { "label-position": "top", "label-width": "auto" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "导入模板" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-download" },
                      on: { click: _vm.handleDownloadGroupShelfTemplate },
                    },
                    [_vm._v("\n          下载导入模板\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入数据" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "groupShelfUploadRef",
                      staticClass: "import-upload",
                      attrs: {
                        limit: 1,
                        accept: ".xlsx",
                        headers: _vm.uploadHeaders,
                        action: _vm.groupShelfUploadUrl,
                        "on-success": _vm.handleGroupShelfUploadSuccess,
                        "on-error": _vm.handleGroupShelfUploadError,
                        "auto-upload": false,
                        disabled: _vm.groupShelfImporting,
                        drag: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n            将文件拖到此处，或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            "\n            只能上传 xlsx 文件，且不超过 5MB\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      _vm.groupShelfImporting &&
                      _vm.groupShelfTaskStatus === "running",
                  },
                  on: {
                    click: function ($event) {
                      _vm.importDialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.groupShelfImporting ? "后台执行中..." : "取消"
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading:
                      _vm.groupShelfImporting && !_vm.groupShelfTaskVisible,
                  },
                  on: { click: _vm.handleConfirmGroupShelfImport },
                },
                [_vm._v("\n        确认导入\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "import-dialog",
          attrs: {
            title: "Excel导入门店",
            visible: _vm.storeImportDialogVisible,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.storeImportDialogVisible = $event
            },
            close: _vm.handleStoreImportDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "storeImportFormRef",
              staticClass: "import-form",
              attrs: {
                model: _vm.storeImportForm,
                "label-position": "top",
                "label-width": "auto",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "操作类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.storeImportForm.operation,
                        callback: function ($$v) {
                          _vm.$set(_vm.storeImportForm, "operation", $$v)
                        },
                        expression: "storeImportForm.operation",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "check" } }, [
                        _vm._v("勾选"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "uncheck" } }, [
                        _vm._v("反选"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入模板" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-download" },
                      on: { click: _vm.handleDownloadStoreTemplate },
                    },
                    [_vm._v("\n          下载导入模板\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "导入数据" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "storeUploadRef",
                      staticClass: "import-upload",
                      attrs: {
                        limit: 1,
                        accept: ".xlsx",
                        headers: _vm.uploadHeaders,
                        action: _vm.uploadUrl,
                        "on-success": _vm.handleStoreUploadSuccess,
                        "on-error": _vm.handleStoreUploadError,
                        "auto-upload": false,
                        data: _vm.storeImportForm,
                        drag: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n            将文件拖到此处，或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            "\n            只能上传 xlsx 文件，且不超过 5MB\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.storeImportDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.storeImporting },
                  on: { click: _vm.handleConfirmStoreImport },
                },
                [_vm._v("\n        确认导入\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "schedule-dialog",
          attrs: {
            title: "定时上下架",
            visible: _vm.scheduleDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.scheduleDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "scheduleFormRef",
              staticClass: "schedule-form",
              attrs: {
                model: _vm.scheduleForm,
                rules: _vm.scheduleRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "任务名称", prop: "taskName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入任务名称",
                      maxlength: "50",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.scheduleForm.taskName,
                      callback: function ($$v) {
                        _vm.$set(_vm.scheduleForm, "taskName", $$v)
                      },
                      expression: "scheduleForm.taskName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "执行时间", prop: "scheduledTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "选择执行时间",
                      "picker-options": _vm.pickerOptions,
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.scheduleForm.scheduledTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.scheduleForm, "scheduledTime", $$v)
                      },
                      expression: "scheduleForm.scheduledTime",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "任务信息确认" } },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { column: 1, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "操作类型" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.scheduleForm.operation === "1"
                                  ? "上架"
                                  : "下架"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-descriptions-item", { attrs: { label: "场景" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.getSceneNames(_vm.scheduleForm.scene)) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "分组数量" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.tableData.length) +
                              " 个\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "门店数量" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.selectedStoreCount) +
                              " 家\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.scheduleDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.scheduleSubmitting },
                  on: { click: _vm.handleConfirmSchedule },
                },
                [_vm._v("\n        确认创建\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "task-manage-dialog",
          attrs: {
            title: "定时任务管理",
            visible: _vm.taskManageDialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.taskManageDialogVisible = $event
            },
            open: _vm.handleQueryScheduledTasks,
          },
        },
        [
          _c(
            "div",
            { staticClass: "task-manage-content" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.taskLoading,
                      expression: "taskLoading",
                    },
                  ],
                  staticClass: "task-table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.taskList,
                    "header-cell-style": _vm.headerCellStyle,
                    "max-height": "500px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "任务ID",
                      width: "80",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "id-tag" }, [
                              _vm._v("#" + _vm._s(scope.row.id)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taskName",
                      label: "任务名称",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "关联分组", width: "120", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.groupIds && scope.row.groupIds.length > 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "view-goods-btn",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleViewRelatedGroups(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-goods" }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row.groupIds.length) +
                                        "个分组\n            "
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "no-goods" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作类型", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.operation === 1
                                      ? "success"
                                      : "info",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.operation === 1
                                        ? "上架"
                                        : "下架"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getTaskStatusType(
                                    scope.row.processStatus
                                  ),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getTaskStatusText(
                                        scope.row.processStatus
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dataTime",
                      label: "计划时间",
                      width: "160",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "180",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.processStatus === 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "cancel-btn",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCancelTask(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              取消\n            ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "delete-btn",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDeleteTask(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "task-pagination" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.taskPagination.page,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.taskPagination.limit,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.taskPagination.total,
                    },
                    on: {
                      "size-change": _vm.handleTaskSizeChange,
                      "current-change": _vm.handleTaskCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.taskManageDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "related-goods-dialog",
          attrs: {
            title: "关联分组列表",
            visible: _vm.relatedGroupsDialogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.relatedGroupsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "related-goods-content" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.relatedGroupsLoading,
                      expression: "relatedGroupsLoading",
                    },
                  ],
                  staticClass: "related-goods-table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.relatedGroupsList,
                    "header-cell-style": _vm.headerCellStyle,
                    "max-height": "400px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "分组ID",
                      width: "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", { staticClass: "id-tag" }, [
                              _vm._v("#" + _vm._s(scope.row.id)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "分组名称",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "regionCategory",
                      label: "适用区域",
                      width: "120",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.relatedGroupsDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-content" }, [
      _c("h1", { staticClass: "page-title" }, [_vm._v("商品分组上下架")]),
      _vm._v(" "),
      _c("p", { staticClass: "page-subtitle" }, [
        _vm._v("管理商品分组在各门店的上下架状态"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }